import { NavLink, Stack } from '@mantine/core';

const topics = [
    { id: 'signing-in', label: 'Signing In' },
    { id: 'single-sign-on', label: 'Single Sign-On (SSO)' },
    { id: 'managing-accounts', label: 'Managing Accounts' },
    { id: 'reset-password', label: 'Reset Password' },
    { id: 'change-password', label: 'Change Password' },
    { id: 'sign-in-profiles', label: 'Sign-In Profiles' },
    { id: 'applications', label: 'Applications' },
    { id: 'user-agreements', label: 'User Agreements' },
    { id: 'troubleshooting', label: 'Troubleshooting' },
];

export const DocumentationSidebar = ({
    activeTopic,
    onTopicSelect,
}: {
    activeTopic: string;
    onTopicSelect: (topicId: string) => void;
}) => {
    return (
        <Stack gap={0}>
            {topics.map((topic) => (
                <NavLink
                    key={topic.id}
                    label={topic.label}
                    active={activeTopic === topic.id}
                    onClick={() => onTopicSelect(topic.id)}
                />
            ))}
        </Stack>
    );
};
